import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    const body = new URLSearchParams({ email });
    await fetch("https://readdy.ai/api/form/d7aqejv6e3lk9704a2gg", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    });
    setSubmitted(true);
    setEmail("");
  };

  return (
    <footer className="bg-[#080810] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#ff6eb4] to-[#4fc3f7]">
                <i className="ri-music-2-fill text-white text-base" />
              </div>
              <span className="text-white font-black text-lg tracking-tight">IdolVerse</span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed mb-5">K-POP 아이돌 IP와 팬 크리에이터를 연결하는 AI 뮤직비디오 & 안무 제작 플랫폼</p>
            <div className="flex gap-3">
              {["ri-twitter-x-line", "ri-instagram-line", "ri-youtube-line", "ri-discord-line"].map((icon) => (
                <a key={icon} href="#" className="w-8 h-8 flex items-center justify-center rounded-full border border-white/20 text-white/50 hover:text-white hover:border-white/40 transition-all cursor-pointer">
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Platform */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">플랫폼</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/artists" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">아이돌 탐색</Link>
              <Link to="/quests" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">캠페인</Link>
              <Link to="/community" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">커뮤니티</Link>
              <Link to="/pricing" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">요금제</Link>
              <Link to="/quests/new" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">캠페인 만들기</Link>
            </div>
          </div>

          {/* Artist */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">아티스트</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/artist-register" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">아티스트 등록</Link>
              <a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">IP 관리</a>
              <a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">캠페인 출제</a>
              <a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">팬 통계</a>
              <a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">고객센터</a>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-2">최신 소식 받기</h4>
            <p className="text-white/40 text-xs mb-4">새로운 캠페인과 아이돌 소식을 받아보세요</p>
            {submitted ? (
              <div className="flex items-center gap-2 text-[#ff6eb4] text-sm">
                <i className="ri-checkbox-circle-line" /> 구독 완료!
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="이메일 주소"
                  className="flex-1 bg-white/5 border border-white/10 rounded-xl px-3 py-2 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#ff6eb4]/50 min-w-0"
                />
                <button type="submit" className="w-9 h-9 flex items-center justify-center rounded-xl bg-gradient-to-r from-[#ff6eb4] to-[#4fc3f7] text-white cursor-pointer flex-shrink-0">
                  <i className="ri-arrow-right-line text-sm" />
                </button>
              </form>
            )}

            <div className="mt-5 pt-5 border-t border-white/8">
              <Link to="/signup" className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl bg-gradient-to-r from-[#ff6eb4]/20 to-[#4fc3f7]/20 border border-[#ff6eb4]/20 text-[#ff6eb4] text-sm font-semibold cursor-pointer hover:opacity-80 transition-opacity whitespace-nowrap">
                <i className="ri-user-add-line" />
                무료로 시작하기
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">© 2026 IdolVerse. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/20 text-xs hover:text-white/40 transition-colors cursor-pointer">이용약관</a>
            <a href="#" className="text-white/20 text-xs hover:text-white/40 transition-colors cursor-pointer">개인정보처리방침</a>
            <p className="text-white/20 text-xs">Powered by AI · Built for K-POP Fans</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
